import { render, staticRenderFns } from "./emptyList.vue?vue&type=template&id=1ad47891&scoped=true&"
import script from "./emptyList.vue?vue&type=script&lang=js&"
export * from "./emptyList.vue?vue&type=script&lang=js&"
import style0 from "./emptyList.vue?vue&type=style&index=0&id=1ad47891&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad47891",
  null
  
)

export default component.exports